import React, { useEffect, useState } from "react";
import img from "../../constant";
import axiosInstance from "../../utility/axiosInstance";
import JobsCreated from "../jobs/dashboard";
import OnboardingGuide from "../../components/elements/OnboardingGuide";

type summaryType = {
  completedInterviews: "";
  scheduledInterviews: "";
  totalJobs: "";
  candidatesCount: "";
};

type usageType = {
  admins: {
    current: number;
    max: number;
    percentage: number;
  };
  interviews: {
    current: number;
    max: number;
    percentage: number;
  };
};

const Dashboard: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [summary, setSummary] = useState<summaryType>();
  const [usage, setUsage] = useState<usageType | null>(null);
  console.log(loading, error);

  const getOrganizationId = (): string | null => {
    try {
      const loginData = localStorage.getItem("loginData");
      if (loginData) {
        const parsedData = JSON.parse(loginData);
        return parsedData.data?.admin?.organization?.id || null;
      }
      return null;
    } catch (err) {
      console.error("Error parsing loginData from localStorage:", err);
      return null;
    }
  };

  const getDashboardSummary = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/admin/summary");
      const result = response.data.result;
      setSummary(result.data);
      console.log(summary);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("An error occurred"));
      console.error("Error fetching summary:", err);
    } finally {
      setLoading(false);
    }
  };

  const getUsageData = async () => {
    try {
      const orgId = getOrganizationId();

      if (!orgId) {
        console.warn("Organization ID not found");
        return;
      }

      const response = await axiosInstance.get(`/organizations/${orgId}/usage`);
      if (response.data?.status === "success" && response.data?.data?.usage) {
        setUsage(response.data.data.usage);
      }
    } catch (err) {
      console.error("Error fetching usage data:", err);
    }
  };

  useEffect(() => {
    getDashboardSummary();
    getUsageData();
  }, []);

  return (
    <div className="w-full py-5">
      <OnboardingGuide run={true} />
      <div className="max-w-[1096px] mx-auto px-3">
        <div className="flex items-center justify-between max-w-[470px] pb-3">
          <div className="flex items-center bg-[#a8d0fa] rounded-full px-3 py-1">
            <p className="text-[16px]">
              Admin Usage: {usage?.admins.current || "0"} /{" "}
              {usage?.admins.max || "0"}
            </p>
            <p className="text-sm ml-1">
              ({usage?.admins.percentage || "0"}% Used)
            </p>
          </div>
          <p className="text-[16px]">|</p>
          <div className="flex items-center bg-[#9cc2f6] rounded-full px-3 py-1">
            <p className="text-[16px]">
              Interviews Usage: {usage?.interviews.current || "0"} /{" "}
              {usage?.interviews.max || "0"}
            </p>
            <p className="text-sm ml-1">
              ({usage?.interviews.percentage || "0"}% Used)
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-4 grid-cols-1 gap-2">
          <div className="col-span-1">
            <div className="bg-[#7791F0] h-[152px] rounded-[8.16px]">
              <div className="bg-bgCard bg-cover bg-center bg-no-repeat w-full h-full px-4 py-3">
                <div className="flex items-center">
                  <img src={img.icon1} alt="25th" />
                  <p className="text-19 pl-5">Completed Interviews</p>
                </div>
                <div className="text-center">
                  <p className="text-52">
                    {summary?.completedInterviews || "0"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-[#A7A7A7] h-[152px] rounded-[8.16px]">
              <div className="bg-bgCard bg-cover bg-center bg-no-repeat w-full h-full px-4 py-3">
                <div className="flex items-center">
                  <img src={img.icon2} alt="25th" />
                  <p className="text-19 pl-5">Scheduled Interviews</p>
                </div>
                <div className="text-center">
                  <p className="text-52">
                    {summary?.scheduledInterviews || "0"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-[#1061B9] text-white h-[152px] rounded-[8.16px]">
              <div className="bg-bgCard bg-cover bg-center bg-no-repeat w-full h-full px-4 py-3">
                <div className="flex items-center">
                  <img src={img.icon3} alt="25th" />
                  <p className="text-19 pl-5">Total Jobs</p>
                </div>
                <div className="text-center">
                  <p className="text-52">{summary?.totalJobs || "0"}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-[#63a0f7] h-[152px] rounded-[8.16px]">
              <div className="bg-bgCard bg-cover bg-center bg-no-repeat w-full h-full px-4 py-3">
                <div className="flex items-center">
                  <img src={img.icon1} alt="25th" />
                  <p className="text-19 pl-5">Total Candidates</p>
                </div>
                <div className="text-center">
                  <p className="text-52">{summary?.candidatesCount || "0"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Usage Cards */}
        {/* <div className="grid md:grid-cols-2 grid-cols-1 gap-2 mt-2">
          <div className="col-span-1">
            <div className="bg-[#a4b6f7] h-[152px] rounded-[8.16px]">
              <div className="bg-bgCard bg-cover bg-center bg-no-repeat w-full h-full px-4 py-3">
                <div className="flex items-center">
                  <img src={img.icon1} alt="25th" />
                  <p className="text-19 pl-5">Admins Usage</p>
                </div>
                <div className="text-center">
                  <p className="text-52">
                    {usage?.admins.current || "0"} / {usage?.admins.max || "0"}
                  </p>
                  <p className="text-sm mt-1">
                    {usage?.admins.percentage || "0"}% Used
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-[#83bbf6] h-[152px] rounded-[8.16px]">
              <div className="bg-bgCard bg-cover bg-center bg-no-repeat w-full h-full px-4 py-3">
                <div className="flex items-center">
                  <img src={img.icon2} alt="25th" />
                  <p className="text-19 pl-5">Interviews Usage</p>
                </div>
                <div className="text-center">
                  <p className="text-52">
                    {usage?.interviews.current || "0"} /{" "}
                    {usage?.interviews.max || "0"}
                  </p>
                  <p className="text-sm mt-1">
                    {usage?.interviews.percentage || "0"}% Used
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <JobsCreated />
    </div>
  );
};

export default Dashboard;
